import { getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import { measuredUsingConfigFor as wrap, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) => {
  return mergeConfig(
    {
      [`${prefix}.Sieves.WetMassPassing`]: { uom: 'g', format: { nearest: 1 } },
      [`${prefix}.Sieves.WetMassRetained`]: { uom: 'g', format: { nearest: 1 } },
      [`${prefix}.Sieves.CumulativeDryMassPassingPercent`]: { format: { nearest: 1 } },
      [`${prefix}.Sieves.CumulativeWetMassPassingPercent`]: { format: { nearest: 1 } },
      [`${prefix}.Sieves.CumulativeDryMassRetainedPercent`]: { format: { nearest: 1 } },
    },
    getLabelConfig(prefix),
    getMeasuredUsingConfig(prefix),
    getConfigForMeasuredTest(
      qestIds.moistureContent.BS_EN_ISO_17892_1.rev2014,
      `${prefix}.EmbeddedWaterContent.MoistureContentTest`
    )
  );
};

const getMeasuredUsingConfig = (prefix: string) => {
  const balance = wrap(`data.Equipment.TareMassBalance`);
  return {
    [`${prefix}.TotalMaterialDryMass`]: balance,
    [`${prefix}.Sieves.WetMassRetained`]: balance,
    [`${prefix}.Sieves.DryMassRetained`]: balance,
    [`${prefix}.Sieves.WetMassPassing`]: balance,
    [`${prefix}.Sieves.DryMassPassing`]: balance,
  };
};

export { getConfig };

export default {
  [qestIds.oversizeDetermination.BS_1377_2_Clause_11]: getConfig,
};
